import { render } from "./Webinar.vue?vue&type=template&id=b05a0fe0"
import script from "./Webinar.vue?vue&type=script&lang=ts"
export * from "./Webinar.vue?vue&type=script&lang=ts"

import "./Webinar.vue?vue&type=style&index=0&id=b05a0fe0&lang=stylus"
script.render = render

export default script